import { render, staticRenderFns } from "./UnknownResultsHeader.vue?vue&type=template&id=212c58a7&scoped=true&"
import script from "./UnknownResultsHeader.vue?vue&type=script&lang=js&"
export * from "./UnknownResultsHeader.vue?vue&type=script&lang=js&"
import style0 from "./UnknownResultsHeader.vue?vue&type=style&index=0&id=212c58a7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c58a7",
  null
  
)

export default component.exports